/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetAppointmentTypeResponse
 */
export interface GetAppointmentTypeResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetAppointmentTypeResponse
     */
    id: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentTypeResponse
     */
    name: string;
}

/**
 * Check if a given object implements the GetAppointmentTypeResponse interface.
 */
export function instanceOfGetAppointmentTypeResponse(value: object): value is GetAppointmentTypeResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function GetAppointmentTypeResponseFromJSON(json: any): GetAppointmentTypeResponse {
    return GetAppointmentTypeResponseFromJSONTyped(json, false);
}

export function GetAppointmentTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAppointmentTypeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
        'name': json['name'],
    };
}

export function GetAppointmentTypeResponseToJSON(json: any): GetAppointmentTypeResponse {
    return GetAppointmentTypeResponseToJSONTyped(json, false);
}

export function GetAppointmentTypeResponseToJSONTyped(value?: GetAppointmentTypeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
        'name': value['name'],
    };
}

